/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-any

/**
 * A fake connection for forwarding all data transparently
 * To be used with CrownProtocolBridge
 */
export class CrownConnectionProxy {
  /**
   * ctor
   * @param _onIncomingData Callback sent data. Forward of send(). Use to
   */
  constructor(_onIncomingData) {
    this._isOpen = false;

    this._onData = _data => {};

    this._onOpen = () => {};

    this._onClose = () => {};

    this._onIncomingData = _onIncomingData;
  }
  /**
   * Put-in a raw JS-object. Simulates receiving data.
   */


  putObj(obj) {
    if (this.open) {
      this._onData(obj);
    }
  }
  /**
   * see base class
   */


  setOnOpen(onOpen) {
    this._onOpen = onOpen;
  }
  /**
   * see base class
   */


  setOnClose(onClose) {
    this._onClose = onClose;
  }
  /**
   * see base class
   */


  setOnData(onData) {
    this._onData = onData;
  }
  /**
   * see base class
   */


  open() {
    this._isOpen = true;

    this._onOpen();
  }
  /**
   * see base class
   */


  close() {
    this._isOpen = false;

    this._onClose();
  }
  /**
   * see base class
   */


  send(data) {
    if (this._isOpen) {
      setTimeout(() => this._onIncomingData(data)); // async behavior
    }
  } // tslint:disable-line:no-empty


}
//# sourceMappingURL=CrownConnectionProxy.js.map